module.exports = __webpack_public_path__ + "img/30_43.6b8cdefc.png";